/* src/app/tools-components/add-edit-modal-PNRR/add-edit-modal-PNRR.component.scss */
.modal-header-content {
  display: flex;
  justify-content: flex-start;
  width: 100%;
  align-items: center;
}
.modal-header-content .ws-img {
  width: 3.125rem;
  height: 3.125rem;
  margin-right: 1rem;
}
.pnrr-dashboard {
  color: #155cb4;
  font-size: 12px;
  cursor: pointer;
}
.ml-4 {
  margin-left: 10px;
}
.mr-4 {
  margin-right: 10px;
}
.form-group {
  margin-bottom: 1.875rem;
}
.form-group:last-child {
  margin-bottom: 0;
}
.form-group .subtitle-input {
  font-size: 0.625rem;
  line-height: 0.75rem;
  font-weight: 300;
  color: rgba(46, 46, 56, 0.64);
  margin: 0.5rem 0 0 0;
}
.custom-checkbox {
  margin-top: 1.875rem;
}
.destination-helper {
  font-size: 0.625rem;
  line-height: 0.75rem;
  font-weight: 300;
  color: rgba(46, 46, 56, 0.64);
  margin: 0.5rem 0 0 0;
}
.custom-control-label {
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 300;
  color: #2e2e38;
}
.custom-control-label::before,
.custom-control-label::after {
  top: 50%;
  transform: translateY(-50%);
}
/*# sourceMappingURL=add-edit-modal-PNRR.component.css.map */
